export interface User {
  id: string;
  userEmail: string;
  firstName: string;
  lastName: string;
  userName: string | null;
  companyName: string | null;
  euVatNumber: string | null;
  phoneNumber: string | null;
  countryCode: string | null;
  state: string | null;
  street: string | null;
  postalCode: string | null;
  city: string | null;
  bio: string | null;
  dxTradeLogin: string;
  dxTradePassword: string;
  ctraderEmail: string;
}

export interface UserCompanyAddressInfo {
  firstName: string;
  lastName: string;
  companyName: string;
  euVatNumber: string;
  phoneNumber: string;
  countryCode: string;
  street: string;
  postalCode: string;
  city: string;
}

export interface UserBillingAddress {
  userEmail: string;
  firstName: string;
  lastName: string;
  address: string;
  country: string;
  city: string;
  street: string;
  countryCode: string;
  phoneNumber: string;
  companyName: string;
  euVatNumber: string;
  terms: boolean;
  privacy: boolean;
}

export type UserUpdateData = Omit<
  User,
  "id" | "userEmail" | "userName" | "dxTradeLogin" | "dxTradePassword"
>;

export enum KycStatus {
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
  NOT_STARTED = "NOT_STARTED",
  STARTED = "STARTED",
  FAILED = "FAILED",
  PASSED = "PASSED",
}

export interface UserKyc {
  status: KycStatus;
  sumSubLink: string | null;
}

export interface UserPayoutMethods {
  erc20AddressUsdc: string | null;
  swiftCode: string | null;
  iban: string | null;
  // The ABA routing number of a US bank account, which a futures payout to it needs
  routingNumber?: string | null;
}

export interface DialogInstance extends UserPayoutMethods {
  isSubmitted?: boolean;
}
